import {
  Typography,
} from "@mui/material";
import { useUIContext } from "../../../state/ui";
import { useAuth } from "../../../hooks/useAuth";

function BrandName() {
  const { drawerOpen } = useUIContext();
  const { user } = useAuth();

  // Get app title: use tenant name if available, otherwise default to "One Vision"
  const appTitle = user?.tenant?.name || 'One Vision';

  return (
    <>
      <Typography
        variant="h6"
        noWrap
        component="div"
        sx={{ flexGrow: 1, color: "#fff", opacity: drawerOpen && 0 }}
      >
        {appTitle}
      </Typography>
    </>
  );
}

export default BrandName;
